import { render, staticRenderFns } from "./star72.vue?vue&type=template&id=a5d19088&scoped=true"
import script from "./star72.vue?vue&type=script&lang=js"
export * from "./star72.vue?vue&type=script&lang=js"
import style0 from "./star72.vue?vue&type=style&index=0&id=a5d19088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d19088",
  null
  
)

export default component.exports